const initialstate = {
    permissions: '',
    user_data:''
  };

  export const login_Permission = (state = initialstate, { type, payload }) => {
    switch (type) {
      case "GET_PERMISSION": {
        return {
          ...state,
          permissions: payload,
        };
      }
      case "SET_USER_INFO":{
        return {
          ...state,
          user_data: payload,
        };
      }
      default: {
        return { ...state };
      }
    }
  };